import { render } from "./VerstaendlichkeitChart.vue?vue&type=template&id=c02ef480&scoped=true"
import script from "./VerstaendlichkeitChart.vue?vue&type=script&lang=js"
export * from "./VerstaendlichkeitChart.vue?vue&type=script&lang=js"

import "./VerstaendlichkeitChart.vue?vue&type=style&index=0&id=c02ef480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02ef480"]])

export default __exports__